import React from "react";
import { Link } from "react-router-dom";
import NavBar from "../components/layout/NavBar";
import Footer from "../components/layout/Footer";

export default function PolitiqueConfidentialite() {
  return (
    <main className="min-h-screen bg-white text-gray-900 pt-20">
      <NavBar />

      <section className="px-6 pt-10 pb-4">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-semibold leading-tight">Politique de confidentialité</h1>
          <p className="mt-3 text-sm text-gray-500">En vigueur au 10/08/2025</p>
        </div>
      </section>

      <section className="px-6 pb-24">
        <div className="max-w-3xl mx-auto space-y-10 text-[15px] leading-7 text-gray-800">

          {/* Préambule */}
          <div>
            <p>
              La société <span className="font-medium">NOXZI</span>, SASU au capital de 100,00 €, immatriculée
              au RCS de Chambéry sous le n° 990 027 377, dont le siège social est situé 792 Chemin de Charrière
              Neuve, 73000 Chambéry, France (ci-après « NOXZI » ou « le Responsable de traitement »), attache
              une importance primordiale à la protection de vos données personnelles et au respect de votre vie
              privée.
            </p>
            <p className="mt-3">
              La présente Politique de confidentialité décrit la manière dont NOXZI collecte, utilise, conserve
              et protège vos données personnelles lorsque vous visitez le site internet{" "}
              <span className="font-medium">noxzi.fr</span> (ci-après « le Site ») ou lorsque vous utilisez
              nos services, conformément au Règlement (UE) 2016/679 du 27 avril 2016 relatif à la protection
              des données personnelles (RGPD) et à la loi n° 78-17 du 6 janvier 1978 modifiée relative à
              l'informatique, aux fichiers et aux libertés (loi Informatique et Libertés).
            </p>
            <p className="mt-3">
              Nous vous invitons à lire attentivement ce document. En utilisant notre Site ou nos services,
              vous reconnaissez avoir pris connaissance de la présente Politique.
            </p>
          </div>

          {/* Art. 1 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 1 — Identité du responsable de traitement</h2>
            <ul className="mt-3 space-y-1 list-none pl-0">
              <li><span className="font-medium">Responsable de traitement :</span> NOXZI</li>
              <li><span className="font-medium">Forme juridique :</span> SASU au capital de 100,00 €</li>
              <li><span className="font-medium">Siège social :</span> 792 Chemin de Charrière Neuve, 73000 Chambéry, France</li>
              <li><span className="font-medium">SIREN :</span> 990 027 377</li>
              <li><span className="font-medium">Représentant légal :</span> Lionel FAURE</li>
              <li><span className="font-medium">Téléphone :</span> +33 (0)6 03 59 99 52</li>
              <li>
                <span className="font-medium">Contact données personnelles :</span>{" "}
                <a href="mailto:contact@noxzi.fr" className="underline">contact@noxzi.fr</a>
              </li>
            </ul>
            <p className="mt-3">
              NOXZI n'est pas tenue de désigner un Délégué à la Protection des Données (DPO) à titre
              obligatoire, sa structure et ses activités n'entrant pas dans les cas prévus par l'article 37
              du RGPD. Toute question relative à la protection des données peut néanmoins être adressée à
              l'adresse e-mail mentionnée ci-dessus.
            </p>
          </section>

          {/* Art. 2 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 2 — Données collectées et finalités</h2>
            <p>
              NOXZI collecte uniquement les données strictement nécessaires à l'exercice de ses activités,
              conformément au principe de minimisation des données (art. 5 RGPD). Le tableau ci-dessous
              récapitule les traitements mis en œuvre :
            </p>

            <div className="mt-5 space-y-6">

              <div className="border border-gray-200 rounded-xl overflow-hidden">
                <div className="bg-gray-50 px-4 py-3 border-b border-gray-200">
                  <p className="font-medium text-[14px] text-black">Formulaire de contact / demande de devis</p>
                </div>
                <div className="px-4 py-3 space-y-2 text-[14px]">
                  <p><span className="text-gray-500">Données collectées :</span> Nom, prénom, adresse e-mail, numéro de téléphone (optionnel), nom de société (optionnel), message.</p>
                  <p><span className="text-gray-500">Finalité :</span> Répondre aux demandes de contact et établir des devis.</p>
                  <p><span className="text-gray-500">Base légale :</span> Exécution de mesures précontractuelles (art. 6.1.b RGPD).</p>
                  <p><span className="text-gray-500">Durée de conservation :</span> 3 ans à compter du dernier contact.</p>
                </div>
              </div>

              <div className="border border-gray-200 rounded-xl overflow-hidden">
                <div className="bg-gray-50 px-4 py-3 border-b border-gray-200">
                  <p className="font-medium text-[14px] text-black">Gestion de la relation client et facturation</p>
                </div>
                <div className="px-4 py-3 space-y-2 text-[14px]">
                  <p><span className="text-gray-500">Données collectées :</span> Coordonnées complètes (nom, adresse, e-mail, téléphone), données de facturation, historique des prestations, échanges contractuels.</p>
                  <p><span className="text-gray-500">Finalité :</span> Exécution des contrats de prestation, facturation, suivi de la relation commerciale.</p>
                  <p><span className="text-gray-500">Base légale :</span> Exécution du contrat (art. 6.1.b RGPD) et obligation légale pour les données comptables (art. 6.1.c RGPD).</p>
                  <p><span className="text-gray-500">Durée de conservation :</span> Durée du contrat + 5 ans (prescription commerciale) pour les données contractuelles ; 10 ans pour les pièces comptables (obligation légale).</p>
                </div>
              </div>

              <div className="border border-gray-200 rounded-xl overflow-hidden">
                <div className="bg-gray-50 px-4 py-3 border-b border-gray-200">
                  <p className="font-medium text-[14px] text-black">Communications commerciales (newsletter, offres)</p>
                </div>
                <div className="px-4 py-3 space-y-2 text-[14px]">
                  <p><span className="text-gray-500">Données collectées :</span> Adresse e-mail, prénom.</p>
                  <p><span className="text-gray-500">Finalité :</span> Envoi de communications marketing et d'informations sur les services NOXZI.</p>
                  <p><span className="text-gray-500">Base légale :</span> Consentement (art. 6.1.a RGPD) pour les particuliers ; intérêt légitime (art. 6.1.f RGPD) pour les clients professionnels existants, conformément à l'article L. 34-5 du Code des postes et des communications électroniques.</p>
                  <p><span className="text-gray-500">Durée de conservation :</span> Jusqu'au retrait du consentement ou désinscription, ou 3 ans après le dernier contact actif.</p>
                </div>
              </div>

              <div className="border border-gray-200 rounded-xl overflow-hidden">
                <div className="bg-gray-50 px-4 py-3 border-b border-gray-200">
                  <p className="font-medium text-[14px] text-black">Navigation sur le Site (données techniques)</p>
                </div>
                <div className="px-4 py-3 space-y-2 text-[14px]">
                  <p><span className="text-gray-500">Données collectées :</span> Adresse IP (pseudonymisée), type de navigateur, pages visitées, durée de session, source de trafic.</p>
                  <p><span className="text-gray-500">Finalité :</span> Mesure d'audience, amélioration des performances du Site, détection des anomalies techniques.</p>
                  <p><span className="text-gray-500">Base légale :</span> Intérêt légitime (art. 6.1.f RGPD) et/ou consentement selon les outils utilisés.</p>
                  <p><span className="text-gray-500">Durée de conservation :</span> 13 mois maximum (recommandation CNIL).</p>
                </div>
              </div>

            </div>
          </section>

          {/* Art. 3 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 3 — Destinataires des données</h2>
            <p>
              Les données personnelles collectées par NOXZI sont destinées exclusivement à son usage interne
              dans le cadre de ses activités. NOXZI ne vend, ne loue et ne cède jamais vos données personnelles
              à des tiers à des fins commerciales.
            </p>
            <p className="mt-3">
              Vos données peuvent toutefois être transmises aux catégories de destinataires suivantes, dans
              le strict cadre de l'exécution des finalités décrites à l'article 2 :
            </p>
            <ul className="mt-3 ml-5 list-disc space-y-2">
              <li>
                <span className="font-medium">Prestataires techniques (sous-traitants) :</span> hébergeur du
                Site (LWS), outils de messagerie électronique, outils de gestion de projet (Notion, Google
                Drive), logiciels de facturation — uniquement dans le cadre de leurs missions et sous contrat
                garantissant un niveau de protection adéquat des données ;
              </li>
              <li>
                <span className="font-medium">Autorités administratives ou judiciaires :</span> uniquement
                sur réquisition légale ou décision de justice ;
              </li>
              <li>
                <span className="font-medium">Conseil juridique ou comptable :</span> dans le cadre des
                obligations légales de NOXZI, sous couvert du secret professionnel.
              </li>
            </ul>
            <p className="mt-3">
              NOXZI s'assure que tout sous-traitant présente des garanties suffisantes quant à la mise en
              œuvre de mesures techniques et organisationnelles appropriées, conformément à l'article 28 du RGPD.
            </p>
          </section>

          {/* Art. 4 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 4 — Transferts de données hors Union européenne</h2>
            <p>
              Dans le cadre de l'utilisation d'outils tiers (Google Drive, Notion, etc.), vos données peuvent
              être transférées et hébergées sur des serveurs situés en dehors de l'Union européenne, notamment
              aux États-Unis.
            </p>
            <p className="mt-3">
              Ces transferts sont encadrés par des garanties appropriées, notamment :
            </p>
            <ul className="mt-2 ml-5 list-disc space-y-1">
              <li>
                Les clauses contractuelles types (CCT) adoptées par la Commission européenne (art. 46.2.c RGPD) ;
              </li>
              <li>
                L'adhésion des prestataires concernés au cadre de protection des données UE–États-Unis (Data
                Privacy Framework), lorsqu'applicable.
              </li>
            </ul>
            <p className="mt-3">
              Vous pouvez obtenir des informations complémentaires sur ces transferts et les garanties associées
              en contactant NOXZI à{" "}
              <a href="mailto:contact@noxzi.fr" className="underline">contact@noxzi.fr</a>.
            </p>
          </section>

          {/* Art. 5 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 5 — Durée de conservation</h2>
            <p>
              NOXZI conserve vos données personnelles pour une durée n'excédant pas celle nécessaire aux
              finalités pour lesquelles elles ont été collectées, conformément au principe de limitation de
              la conservation (art. 5.1.e RGPD).
            </p>
            <p className="mt-3">Les durées de conservation applicables sont les suivantes :</p>
            <ul className="mt-3 ml-5 list-disc space-y-2">
              <li>
                <span className="font-medium">Données prospects (non convertis) :</span> 3 ans à compter
                du dernier contact actif ;
              </li>
              <li>
                <span className="font-medium">Données clients :</span> durée du contrat + 5 ans au titre
                de la prescription légale civile et commerciale ;
              </li>
              <li>
                <span className="font-medium">Pièces comptables et factures :</span> 10 ans à compter de
                la clôture de l'exercice (obligation légale, art. L. 123-22 Code de commerce) ;
              </li>
              <li>
                <span className="font-medium">Données de navigation :</span> 13 mois maximum (recommandation CNIL) ;
              </li>
              <li>
                <span className="font-medium">Données de consentement marketing :</span> jusqu'au retrait
                du consentement ou 3 ans après le dernier contact actif.
              </li>
            </ul>
            <p className="mt-3">
              À l'issue de ces délais, les données sont supprimées de manière sécurisée ou anonymisées
              de façon irréversible.
            </p>
          </section>

          {/* Art. 6 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 6 — Vos droits</h2>
            <p>
              Conformément au RGPD et à la loi Informatique et Libertés, vous disposez des droits suivants
              sur vos données personnelles :
            </p>

            <div className="mt-4 space-y-3">
              {[
                { droit: "Droit d'accès (art. 15 RGPD)", desc: "Vous pouvez obtenir la confirmation que des données vous concernant sont traitées, ainsi qu'une copie de ces données." },
                { droit: "Droit de rectification (art. 16 RGPD)", desc: "Vous pouvez demander la correction de données inexactes ou incomplètes vous concernant." },
                { droit: "Droit à l'effacement (art. 17 RGPD)", desc: "Vous pouvez demander la suppression de vos données dans les cas prévus par la réglementation (retrait du consentement, données inutiles, etc.), sous réserve des obligations légales de conservation." },
                { droit: "Droit à la limitation du traitement (art. 18 RGPD)", desc: "Vous pouvez demander la suspension temporaire du traitement de vos données dans certaines circonstances." },
                { droit: "Droit à la portabilité (art. 20 RGPD)", desc: "Vous pouvez recevoir vos données dans un format structuré et lisible par machine, ou demander leur transfert à un autre responsable de traitement." },
                { droit: "Droit d'opposition (art. 21 RGPD)", desc: "Vous pouvez vous opposer à tout moment au traitement de vos données fondé sur l'intérêt légitime, notamment à des fins de prospection commerciale." },
                { droit: "Droit de retrait du consentement", desc: "Lorsque le traitement est fondé sur votre consentement, vous pouvez le retirer à tout moment, sans que cela remette en cause la licéité des traitements effectués avant ce retrait." },
                { droit: "Droit de définir des directives post-mortem", desc: "Vous pouvez définir des directives relatives à la conservation, à l'effacement et à la communication de vos données après votre décès." },
              ].map(({ droit, desc }) => (
                <div key={droit} className="pl-4 border-l-2 border-gray-200">
                  <p className="font-medium text-[14px] text-black">{droit}</p>
                  <p className="text-[14px] text-gray-600 mt-0.5">{desc}</p>
                </div>
              ))}
            </div>

            <h3 className="font-medium mt-6 mb-2">Comment exercer vos droits ?</h3>
            <p>
              Pour exercer l'un de ces droits, adressez votre demande accompagnée d'une copie de votre
              pièce d'identité à :
            </p>
            <ul className="mt-2 ml-5 list-disc space-y-1">
              <li>
                Par e-mail : <a href="mailto:contact@noxzi.fr" className="underline">contact@noxzi.fr</a>
              </li>
              <li>
                Par courrier : NOXZI — 792 Chemin de Charrière Neuve, 73000 Chambéry, France
              </li>
            </ul>
            <p className="mt-3">
              NOXZI s'engage à répondre à votre demande dans un délai d'un (1) mois à compter de sa
              réception. Ce délai peut être prolongé de deux mois supplémentaires en cas de demande complexe
              ou multiple, avec information préalable du demandeur.
            </p>

            <h3 className="font-medium mt-6 mb-2">Droit d'introduire une réclamation</h3>
            <p>
              Si vous estimez que vos droits ne sont pas respectés, vous avez le droit d'introduire une
              réclamation auprès de la Commission Nationale de l'Informatique et des Libertés (CNIL) :
            </p>
            <ul className="mt-2 ml-5 list-disc space-y-1">
              <li>3 Place de Fontenoy — TSA 80715 — 75334 Paris Cedex 07</li>
              <li>
                <a href="https://www.cnil.fr" target="_blank" rel="noreferrer" className="underline">
                  www.cnil.fr
                </a>
              </li>
            </ul>
          </section>

          {/* Art. 7 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 7 — Sécurité des données</h2>
            <p>
              NOXZI met en œuvre les mesures techniques et organisationnelles appropriées pour garantir
              un niveau de sécurité adapté au risque, conformément à l'article 32 du RGPD. Ces mesures
              comprennent notamment :
            </p>
            <ul className="mt-3 ml-5 list-disc space-y-2">
              <li>Le chiffrement des données en transit (protocole HTTPS/TLS) ;</li>
              <li>La gestion sécurisée des accès et des mots de passe (gestionnaire de mots de passe, authentification forte) ;</li>
              <li>La restriction de l'accès aux données aux seules personnes habilitées ;</li>
              <li>Des sauvegardes régulières des données ;</li>
              <li>La mise à jour régulière des systèmes et logiciels utilisés.</li>
            </ul>
            <p className="mt-3">
              En cas de violation de données personnelles susceptible d'engendrer un risque pour vos droits
              et libertés, NOXZI s'engage à notifier la CNIL dans les 72 heures conformément à l'article 33
              du RGPD, et à vous en informer sans délai injustifié si le risque est élevé, conformément à
              l'article 34 du RGPD.
            </p>
          </section>

          {/* Art. 8 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 8 — Cookies</h2>
            <p>
              Le Site utilise des cookies et technologies similaires. Pour toute information détaillée sur
              les cookies utilisés, leur finalité et la manière de les gérer, veuillez consulter notre{" "}
              <Link to="/politique-de-cookies" className="underline">Politique de cookies</Link>.
            </p>
          </section>

          {/* Art. 9 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 9 — Mineurs</h2>
            <p>
              Le Site et les services de NOXZI sont destinés à un public adulte. NOXZI ne collecte pas
              sciemment de données personnelles concernant des mineurs de moins de 15 ans sans le
              consentement préalable des titulaires de l'autorité parentale.
            </p>
            <p className="mt-3">
              Si vous êtes parent ou tuteur et que vous pensez que votre enfant nous a fourni des données
              personnelles, contactez-nous à{" "}
              <a href="mailto:contact@noxzi.fr" className="underline">contact@noxzi.fr</a> afin que nous
              puissions procéder à leur suppression.
            </p>
          </section>

          {/* Art. 10 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 10 — Liens vers des sites tiers</h2>
            <p>
              Le Site peut contenir des liens vers des sites internet de tiers. NOXZI n'est pas responsable
              des pratiques de confidentialité de ces sites et vous encourage à consulter leurs politiques
              de protection des données respectives. La présente Politique de confidentialité s'applique
              exclusivement au Site noxzi.fr.
            </p>
          </section>

          {/* Art. 11 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 11 — Mise à jour de la politique</h2>
            <p>
              La présente Politique de confidentialité peut être mise à jour à tout moment, notamment pour
              se conformer à l'évolution de la réglementation applicable, aux décisions de la CNIL ou à
              l'évolution des services de NOXZI. La date de dernière mise à jour est indiquée en haut de
              ce document.
            </p>
            <p className="mt-3">
              En cas de modification substantielle affectant vos droits, NOXZI s'engage à vous en informer
              par e-mail ou par un avis visible sur le Site avant l'entrée en vigueur des changements.
              La poursuite de l'utilisation du Site après mise à jour vaut acceptation de la nouvelle version.
            </p>
          </section>

        </div>
      </section>

      <Footer />
    </main>
  );
}
